import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { map, sortBy } from 'lodash/collection';
import { translate } from 'react-i18next';
import { scroller } from 'react-scroll';

import SimpleBox from '../../components/SimpleBox/';
import AppIcon from '../../components/AppIcon';
import { scrollSettings } from '../../util/constants';

class SelectEmployerDepartment extends Component {
  constructor(props) {
    super(props);
    this.onHideModal = this.onHideModal.bind(this);
    this.onSelectDepartment = this.onSelectDepartment.bind(this);
    this.onSelectEmployer = this.onSelectEmployer.bind(this);
  }

  componentWillMount() {
    this.autoSelectDepartment();
  }

  componentDidUpdate(prevProps, prevState) {
    this.autoSelectDepartment();
    // If we are about to hide this modal then...
    const isGoingToClose = prevProps.show && !this.props.show;
    if (isGoingToClose) {
      // ...set a timeout to scroll to the booking-start element.
      setTimeout(() => {
        scroller.scrollTo('main-page-booking-start', scrollSettings);
      }, 500);
    }
  }

  onSelectDepartment(department) {
    this.props.selectEmployerDepartment({
      hasEmployer: true,
      hasDepartment: true,
      department
    });
  }

  onSelectEmployer(employerIndex) {
    this.props.selectEmployer(employerIndex);
  }

  onHideModal() {
    this.setState(this.initialState);
    this.props.logout();
  }

  getEmployers() {
    const employers = this.props.user.employers || [];
    // We need to store the index before sorting to reference the right department.
    const employerList = map(employers || [], (e, index) => ({ ...e, index }));
    return sortBy(employerList, e => e.name);
  }

  getDepartments(employerIndex) {
    const employers = this.props.user.employers || [];
    const employer = employers[employerIndex] || {};
    const employerDepartments = 'departments' in employer ? employer.departments : [];
    // We need to store the index before sorting to reference the right department.
    const departmentList = map(employerDepartments || [], (d, index) => ({ ...d, index }));
    return sortBy(departmentList, d => d.name);
  }

  autoSelectDepartment() {
    // Auto-select the department if there is only one.
    const { selectedEmployer } = this.props;
    if (selectedEmployer === -1) {
      return;
    }
    // up to this point there is a selected employer
    // get the departments of the employer
    // this method returns an empty array if there are no departments
    const departments = this.getDepartments(selectedEmployer);
    // if we have only one or no department then we skip the selection
    if (departments.length < 2) {
      // Select employer and don't show department selection.
      this.props.selectEmployerDepartment({
        hasEmployer: true,
        hasDepartment: false,
        department: -1
      });
    }
  }

  render() {
    const { show, selectedEmployer, user, t } = this.props;

    const employerSelection =
      selectedEmployer === -1 ?
        (
          <SimpleBox>
            <div className="box-header">
              <h1 tabIndex={0} className={'select-employer'}>{t('selectEmployerDepartment.chooseEmployerTitle')}</h1>
              <p>
                { map(this.getEmployers(), e => (
                  <Button
                    key={e.name}
                    className="action-btn-small select-department-button"
                    onClick={() => { this.onSelectEmployer(e.index) }}
                  >
                    {e.name}
                  </Button>
                )) }
              </p>
            </div>
          </SimpleBox>
        ) : null;

    const departmentSelection =
      selectedEmployer > -1 ?
        (
          <SimpleBox>
            <div className="box-header">
              <h1>{user.employers[selectedEmployer].name}</h1>
              <h1>{t('selectEmployerDepartment.chooseDepartmentTitle')}</h1>
              <p>
                { map(this.getDepartments(selectedEmployer), d => (
                  <Button
                    key={d.name}
                    className="action-btn-small select-department-button"
                    onClick={() => { this.onSelectDepartment(d.index) }}
                  >
                    {d.name}
                  </Button>
                )) }
              </p>
            </div>
          </SimpleBox>
        ) : null;

    return (
      <Modal
        className="select-employer-department-screen"
        show={show}
        backdrop="static"
        keyboard={false}
      >
        <Button
          bsStyle="link"
          className="close-link basic-action-link"
          onClick={() => { this.onHideModal() }}
        >
          <AppIcon iconName="CLOSE" containerClass="close-icon" />
        </Button>
        {employerSelection}
        {departmentSelection}
      </Modal>
    );
  }
}

SelectEmployerDepartment.propTypes = {
  show: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    employers: PropTypes.array.isRequired
  }).isRequired,
  selectEmployer: PropTypes.func.isRequired,
  selectEmployerDepartment: PropTypes.func.isRequired,
  selectedEmployer: PropTypes.number.isRequired,
  logout: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

SelectEmployerDepartment.defaultProps = {};

export default translate(['booking'])(SelectEmployerDepartment);



// WEBPACK FOOTER //
// ./src/containers/SelectEmployerDepartment/SelectEmployerDepartment.jsx